import { useContext } from 'react';
import { FormContext } from '../context';
export default function useFormInstance() {
  const {
    form
  } = useContext(FormContext);
  return form;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/hooks/useFormInstance.js
// module id = 3859
// module chunks = 0